import styled from "styled-components";
import { isWhite } from "../../menu-item/menu-item.styles";

interface ColorsProps {
  textBody?: string;
  cardBackground?: string;
  headerModalBackground?: string;
  activeBgHeaderModal?: boolean;
}

export const EmptyContainer = styled.div<ColorsProps>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: ${({
    cardBackground,
    headerModalBackground,
    activeBgHeaderModal,
  }) => (activeBgHeaderModal ? headerModalBackground : cardBackground)};
  border: 1px solid
    ${({ cardBackground, activeBgHeaderModal }) =>
      isWhite(cardBackground) && !activeBgHeaderModal
        ? "#eaecf0"
        : "transparent"};
  box-shadow: ${({ cardBackground, activeBgHeaderModal }) =>
    isWhite(cardBackground) && !activeBgHeaderModal
      ? "0px 1px 2px 0px rgba(16, 24, 40, 0.05)"
      : "none"};
  border-radius: 8px;

  padding: ${({ activeBgHeaderModal }) =>
    activeBgHeaderModal ? "42px 16px 56px" : "32px 16px"};

  min-height: 274px;

  @media screen and (max-width: 768px) {
    min-height: 226px;
  }
`;

export const NoMatchingIconContainer = styled.div`
  display: flex;
  margin-bottom: 17px;
`;

export const TextBold = styled.div<ColorsProps>`
  font-size: 18px;
  line-height: 28px;
  font-weight: 600;
  text-align: center;
  color: ${({ textBody }) => textBody};
  margin-bottom: 8px;

  @media screen and (max-width: 768px) {
    font-size: 16px;
    line-height: 24px;
  }
`;

export const TextSmall = styled.div<ColorsProps>`
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  text-align: center;
  color: ${({ textBody }) => textBody};

  @media screen and (max-width: 768px) {
    font-size: 14px;
    line-height: 20px;
  }
`;

export const ButtonContainer = styled.div`
  margin-top: 24px;
  width: 100%;
`;
